// extracted by mini-css-extract-plugin
export default {"searchBox":"searchBox__iwccIuZV","searchInputIndicators":"searchInputIndicators__oxMwGvVn"};